declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

let pixelInitialized = false

export function initMetaPixel() {
  if (pixelInitialized) return
  pixelInitialized = true

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    b.head.appendChild(t)
  }

  window.fbq('init', '26380094205008965')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
